"use client";
import Image, { StaticImageData } from "next/image";
import { AspectRatio, Box, Center, SimpleGrid, VStack } from "@chakra-ui/react";
import { Heading } from "@/elements";
import { DATA_CENTER_CONSTANTS, PLANNED_SERVICE_LOCATIONS } from "./constants";
import DataCenterLocation from "./dataCenterLocation";

type Props = { locations: { id: number; image: StaticImageData; name: string }[] };

const LocationsLayout = (props: Props) => {
  const { locations } = props;
  return (
    <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} gap={6} w={"full"}>
      {locations.map((item) => {
        const { id, image, name } = item;
        return (
          <VStack key={id}>
            <AspectRatio ratio={2 / 1} w="full">
              <Box height="100%" position="relative" width="100%">
                <Image
                  alt={name}
                  fill
                  src={image}
                  style={{ objectFit: "cover", objectPosition: "center" }}
                />
              </Box>
            </AspectRatio>
            <Heading as="h3" variant={"subTitle3"}>
              {name}
            </Heading>
          </VStack>
        );
      })}
    </SimpleGrid>
  );
};

const PlannedServiceLocations = () => {
  return <LocationsLayout locations={PLANNED_SERVICE_LOCATIONS} />;
};

export const tablist = [
  {
    component: <DataCenterLocation />,
    label: () => (
      <Center>
        <Heading fontWeight={600} variant={"subTitle3"}>
          {DATA_CENTER_CONSTANTS.ACTIVE_SERVICE_LOCATION}
        </Heading>
      </Center>
    ),
  },
  {
    component: <PlannedServiceLocations />,
    label: () => (
      <Center>
        <Heading fontWeight={600} variant={"subTitle3"}>
          {DATA_CENTER_CONSTANTS.PlANNED_SERVICE_LOCATIONS}
        </Heading>
      </Center>
    ),
  },
];
